import { ImageStrapiType } from '@/strapi-types';

const buildImageUrl = (src: string, baseUrl: string) => {
  if (src.startsWith('http')) return src;
  if (src.startsWith('/uploads/')) return `${baseUrl}${src}`;
  return src;
};

export const getImageUrl = (image?: ImageStrapiType | null) => {
  const baseUrl = process.env.NEXT_PUBLIC_STRAPI_URL || '';
  const fallbackSrc = '/logo/smzh-new.png';

  return buildImageUrl(image?.url || fallbackSrc, baseUrl);
};
